import { useQuery } from '@tanstack/react-query';
import { listPlans } from '../services/plans.api';
import type { PlanListQuery } from '../types';

export function usePlans(query?: PlanListQuery) {
  return useQuery({
    queryKey: ['plans', 'list', query],
    queryFn: () => listPlans(query),
  });
}
